export const ASSET_TYPES = {
  program: {
    label: 'Program/BU',
    type: 'program',
    id: 'programId',
  },
  rig: {
    label: 'Rig',
    type: 'rig',
    id: 'rigId',
  },
  well: {
    label: 'Well',
    type: 'well',
    id: 'wellId',
  },
  asset: {
    label: 'Asset',
    type: 'asset',
    id: 'assetId',
  },
  frac_fleet: {
    label: 'Frac Fleet',
    type: 'frac_fleet',
    id: 'fracFleetId',
  },
  pad: {
    label: 'Pad',
    type: 'pad',
    id: 'padId',
  },
  drillout_unit: {
    label: 'Drillout Unit',
    type: 'drillout_unit',
    id: 'drilloutUnitId',
  },
  intervention_unit: {
    label: 'Intervention',
    type: 'intervention_unit',
    id: 'interventionUnitId',
  },
};
